exports.en = {
  UNIFORM_DETAIL: {
    INVALID_INPUT: 'Error.',
    INVALID_TEL: 'Invalid phone number format.',
    INVALID_TEL_1_800: 'Invalid phone number format.',
    ERROR_REQUIRED: 'Please fill in.',
    ERROR_PATTERN: 'Wrong format.',
    ERROR_MINLENGTH: 'Required minimum length.',
    ERROR_MAXLENGTH: 'Required maximum length.',
    INVALID_BIRTHNUMBER_MODULO: 'You entered your birth number in the wrong format.'
  }
}
